import { api } from 'common';

import { GetSftpFileFormFields } from './FormFields';
import { GetSftpFileDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';
import { sharedRestBlockDefaultConfig } from '../Rest/Shared/constants';

export const getSftpFileConfig: BlockConfigProps<
  api.FlowDefinition.RestApiClassicAuthorization['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'getSftpFile',
  defaultConfig: {
    ...sharedRestBlockDefaultConfig,
    apiInstanceId: '',
  },
  configFields: {
    schema: api.FlowDefinition.GetSftpFileBlockConfigSchema,
    FormFields: GetSftpFileFormFields,
  },
  documentationMarkdown: GetSftpFileDocumentation,
};
